import { Injectable } from '@angular/core';
import { AutopropBackend, Response } from 'app/shared/backend';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Notification, ReadState } from './notifications.model';


interface HideNotificationResponse extends Response {
    payload: { notificationId: string };
}

interface ChangeMultipleReadStateResponse extends Response {
    payload: { notifications: ReadState[] };
}


type Preferences = {
    sendNotificationsEmail: boolean;
    notificationsRecurrence: number;
}


interface PreferencesResponse extends Response {
    payload: Preferences;
}

@Injectable({
    providedIn: 'root',
})
export class NotificationsApi {

    constructor(private backend: AutopropBackend) {}

    fetchNotifications(): Observable<Notification[]> {
        return this.backend.get('/api/notifications/list').pipe(map(r => r.payload));
    }

    changeReadState(notifications: ReadState[]) {
        return this.backend.post<ChangeMultipleReadStateResponse>('/api/notifications/change-multiple-read-state', { notifications })
            .pipe(map(r => r.payload));
    }

    hideNotification(notificationId: string) {
        return this.backend.post<HideNotificationResponse>('/api/notification/hide', { notificationId }).pipe(map(r => r.payload));
    }

    setPreferences(preferences: Partial<Preferences>) {
        return this.backend.post<PreferencesResponse>('/api/notifications/preferences', preferences).pipe(map(r => r.payload));
    }
}
